export class category{
    _id:any;
    id:any;
    name:string
   adminId:any
   adminUserName:any
    logo:any
    status:boolean
}